import config from "../../config"
import RequestService from "../RequestService"

const createCustomerWaiver = (params, successCallback, failureCallback) => {
  RequestService.post(`${config.backendUrlV2}/customer_waivers`, { customer_waiver: params }, successCallback, failureCallback)
}

export default createCustomerWaiver;